import { StatusObj } from "../Utility/StatusObj";
import moment from "moment-jalaali";

class CellGenerator {
  InitialWeeklyCell(step) {
    moment.locale("en");
    return {
      INDEX: 0,
      isUpdated: false,
      Start: 0,
      End: step,
      startHour: 0,
      startMin: 0,
      endHour: Math.floor(step),
      endMin: step % 1 !== 0 ? 30 : 0,
      status: StatusObj.NotAvailable,
    };
  }
  InitialCalendarCell(firstDay, step) {
    moment.locale("en");
    return {
      ID: 0,
      key: moment(
        new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
      ).valueOf(),
      // key: IDGenerator.DateTimeIndexFormat(0, firstDay, step),
      INDEX: 0,
      Start: 0,
      End: step,
      startHour: 0,
      startMin: 0,
      endHour: Math.floor(step),
      endMin: step % 1 !== 0 ? 30 : 0,
      date: moment(
        new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
      ),
      date_time: moment(
        new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
      ).format("YYYY-MM-DDTHH:mm:ssZ"),
      status: StatusObj.NotAvailable,
      initialStatus: StatusObj.NotAvailable,
    };
  }
  WeeklyCell(Arr, i, step) {
    moment.locale("en");
    return {
      INDEX: i,
      isUpdated: false,
      Start: Arr[i - 1].End,
      End: Arr[i - 1].End + step,
      startHour:
        Arr[i - 1].End < 24
          ? Math.floor(Arr[i - 1].End)
          : Math.floor(Arr[i - 1].End) % 24,
      startMin: Arr[i - 1].End % 1 !== 0 ? 30 : 0,
      endHour:
        Arr[i - 1].End < 24
          ? Math.floor(Arr[i - 1].End + step)
          : Math.floor(Arr[i - 1].End + step) % 24,
      endMin: (Arr[i - 1].End + step) % 1 !== 0 ? 30 : 0,
      status: StatusObj.NotAvailable,
    };
  }
  CalendarCell(Arr, i, firstDay, step) {
    moment.locale("en");
    return {
      ID: 0,
      key: moment(
        new Date(
          firstDay.Year,
          firstDay.Month,
          firstDay.Day,
          0,
          i * step * 60,
          0
        )
      ).valueOf(),
      INDEX: i,
      Start: Arr[i - 1].End,
      End: Arr[i - 1].End + step,
      startHour:
        Arr[i - 1].End < 24
          ? Math.floor(Arr[i - 1].End)
          : Math.floor(Arr[i - 1].End) % 24,
      startMin: Arr[i - 1].End % 1 !== 0 ? 30 : 0,
      endHour:
        Arr[i - 1].End < 24
          ? Math.floor(Arr[i - 1].End + step)
          : Math.floor(Arr[i - 1].End + step) % 24,
      endMin: (Arr[i - 1].End + step) % 1 !== 0 ? 30 : 0,
      date: moment(
        new Date(
          firstDay.Year,
          firstDay.Month,
          firstDay.Day,
          0,
          i * step * 60,
          0
        )
      ),
      date_time: moment(
        new Date(
          firstDay.Year,
          firstDay.Month,
          firstDay.Day,
          0,
          i * step * 60,
          0
        )
      ).format("YYYY-MM-DDTHH:mm:ssZ"),
      status: StatusObj.NotAvailable,
      initialStatus: StatusObj.NotAvailable,
    };
  }
  WeeklyGenerator(Arr, step) {
    for (let i = 1; i < 7 * (24 / step); i++) {
      Arr.push(this.WeeklyCell(Arr, i, step));
    }
  }
  CalendarGenarator(Arr, firstDay, step) {
    for (let i = 1; i < 7 * (24 / step); i++) {
      Arr.push(this.CalendarCell(Arr, i, firstDay, step));
    }
  }
}
export default new CellGenerator();
